// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 分页查询任务列表
 * @param params
 * @returns {*}
 */
export function pageTask(params) {
  return axios.post('/schedule/task/page', params).then(res => res.data);
}
/**
 * 根据id修改状态
 * @returns {*}
 */
export function updateStatus(id, params) {
  return axios.get('/schedule/task/updateStatus/' + id, {params: params}).then(res => res.data);
}

/**
 * 查询任务类型
 * @returns {*}
 */
export function listTaskType() {
  return axios.get('/schedule/task/listTaskType').then(res => res.data);
}

/**
 * 保存任务
 * @param params
 * @returns {*}
 */
export function saveTask(params) {
  return axios.post('/schedule/task/add', params).then(res => res.data);
}

/**
 * 更新任务
 * @param params
 * @returns {*}
 */
export function updateTask(params) {
  return axios.post('/schedule/task/update', params).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/schedule.js